import React, {useState} from 'react';
import {Container, Typography, Box} from '@mui/material';
import {forgot} from '../services/api';
import ForgotForm from "../components/ForgotForm";

const ForgotPassword: React.FC = () => {
    const [loading, setLoading] = useState<boolean | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean | null>(null);
    const validateEmail = (email: any) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleForgot = async (data: { email: string }) => {
        if (!validateEmail(data.email)){
            setError('Error email')
            return
        }
        try {
            setLoading(true)
            const response = await forgot(data.email);
            console.log('Restore successful:', response.data);
            setLoading(false)
            setSuccess(true)
            // navigate('/login'); // Перенаправление на страницу входа после успешной регистрации
        } catch (error: any) {
            // const response = await forgot(data.email);
            setError(error.response.data.detail)
            setLoading(false)
            console.error('Login failed:', error.response.data.detail);
        }
    };

    return (
        <Box sx={{display: 'flex', height: '100vh'}}>
            {/* Левая часть с фоновым изображением */}
            <Box
                sx={{
                    margin: '4px',
                    borderRadius: '12px',
                    flex: 1,
                    backgroundImage: 'url(https://static.productscript.ru/uploads/images/pattern.jpg)',
                    backgroundSize: 'cover'
                }}
            />
            <Container component="main" maxWidth="xs">
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100vh'
                }}>
                    <Box sx={{mt: 6}}>
                        <img src="/logo.svg" className='startLogo' alt=""/>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                        <ForgotForm onSubmit={handleForgot} buttonText="Восстановить" loading={loading} error={error} success={success}/>
                    </Box>
                    <Box sx={{
                        mb: 4,
                        mt: 7,
                        display: 'block',
                        justifyContent: 'space-between',
                        width: '100%',
                        textAlign: 'center',
                        color: '#888'
                    }}>
                        2024
                    </Box>

                </Box>
            </Container>
        </Box>
    );
};

export default ForgotPassword;
